import { brandIdentityKey } from './brandIdentity';

/**
 * Render-time brand label aliases, keyed by `brandIdentityKey` (lowercase,
 * punctuation-free). Display only: stored brand ids and names are never
 * rewritten, and filters/links keep using the raw value.
 */
const BRAND_DISPLAY_ALIASES: Record<string, string> = {
  omsystem: 'OM System',
};

/** Returns the display label for a brand id or name ("omsystem" -> "OM System"); other values pass through trimmed. */
export function brandDisplayName(raw?: string | null): string {
  const value = String(raw ?? '').trim();
  if (!value) return '';
  return BRAND_DISPLAY_ALIASES[brandIdentityKey(value)] ?? value;
}
